module.exports = __webpack_public_path__ + "static/media/ceilings_allImpact_10y_n.6aa0fc1e.csv";